import React from 'react'
import {
  useSection,
  Section,
  SectionHeader,
  SectionTitleSuffix,
  SectionContent,
} from 'components/Section'
import { observer } from 'mobx-react'
import { TableRow, TableHead, TableHeader, TableBody } from 'components/Table'
import ScopeChangeRequestDetailsViewModel from '../../ScopeChangeRequestDetailsViewModel'
import cx from 'classnames'
import styles from './BundlesSection.sass'
import { ScopeChangePriceBreakDownItemForAdmin } from '../../../../ScopeChangeRequest'
import ServiceTableHeader from '../components/ServiceTableHeader'
import QuantityCell from '../components/QuantityCell'
import ServiceCell from '../components/ServiceCell'
import MoneyCell from '../components/MoneyCell'
import { ScopeChangeRequestBreakdownTable } from '../components/ScopeChangeRequestBreakdownTable'

interface BundleRowProps {
  vm: ScopeChangePriceBreakDownItemForAdmin
}

const BundleRow = observer(function BundleRow({ vm }: BundleRowProps) {
  return (
    <TableRow>
      <QuantityCell>{vm.quantityDiff}</QuantityCell>
      <ServiceCell>{vm.displayName}</ServiceCell>
      <MoneyCell
        editable={false}
        model={vm}
        dataTest="scope-change-request-bundle-price"
        field="priceDiff"
      >
        {vm.priceDiff}
      </MoneyCell>
      <MoneyCell
        editable={false}
        model={vm}
        dataTest="scope-change-request-bundle-pro-price"
        field="proPriceDiff"
      >
        {vm.proPriceDiff}
      </MoneyCell>
    </TableRow>
  )
})

interface BundlesSectionProps {
  vm: ScopeChangeRequestDetailsViewModel
}

export default observer(function BundlesSection({ vm }: BundlesSectionProps) {
  const sectionProps = useSection(false)

  return (
    <Section
      {...sectionProps}
      collapsed={!vm.bundlesExpanded}
      onToggleCollapse={vm.toggleBundlesSection}
    >
      <SectionHeader borderless>
        <div>
          Bundles{' '}
          <SectionTitleSuffix>
            ({vm.scopeChangeRequestPriceBreakDown.bundleScopeChangeItems.length}
            )
          </SectionTitleSuffix>
        </div>
      </SectionHeader>
      <SectionContent>
        <ScopeChangeRequestBreakdownTable>
          <TableHead className={cx(styles.tableHead)}>
            <TableHeader
              className={cx(styles.quantityTableHeader)}
            ></TableHeader>
            <ServiceTableHeader align="left">Bundle</ServiceTableHeader>
            <ServiceTableHeader align="right">Client fee</ServiceTableHeader>
            <ServiceTableHeader align="right">Pro cut</ServiceTableHeader>
          </TableHead>
          <TableBody>
            {vm.scopeChangeRequestPriceBreakDown.bundleScopeChangeItems.map(
              (item, i) => (
                <BundleRow vm={item} key={i} />
              ),
            )}
          </TableBody>
        </ScopeChangeRequestBreakdownTable>
      </SectionContent>
    </Section>
  )
})
